"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.STACK_VERTICAL_ALIGNMENT = exports.STACK_SPACING = exports.STACK_HORIZONTAL_ALIGNMENT = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "className", "element", "horizontalAlignment", "spacing", "vertical", "verticalAlignment", "wrap"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var STACK_SPACING = ["small", "medium", "large"];
exports.STACK_SPACING = STACK_SPACING;
var STACK_VERTICAL_ALIGNMENT = ["top", "center", "bottom"];
exports.STACK_VERTICAL_ALIGNMENT = STACK_VERTICAL_ALIGNMENT;
var STACK_HORIZONTAL_ALIGNMENT = ["left", "center", "right"];
exports.STACK_HORIZONTAL_ALIGNMENT = STACK_HORIZONTAL_ALIGNMENT;

var Stack = function Stack(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      element = _ref.element,
      horizontalAlignment = _ref.horizontalAlignment,
      spacing = _ref.spacing,
      vertical = _ref.vertical,
      verticalAlignment = _ref.verticalAlignment,
      wrap = _ref.wrap,
      rest = _objectWithoutProperties(_ref, _excluded);

  var stackClasses = (0, _classnames.default)("rds-Stack", (_classNames = {
    "rds-Stack--vertical": vertical
  }, _defineProperty(_classNames, "rds-Stack--".concat(horizontalAlignment, "HorizontalAlignment"), horizontalAlignment !== "left"), _defineProperty(_classNames, "rds-Stack--".concat(spacing, "Spacing"), spacing !== "medium"), _defineProperty(_classNames, "rds-Stack--".concat(verticalAlignment, "VerticalAlignment"), verticalAlignment !== "center"), _defineProperty(_classNames, "rds-Stack--noWrap", !wrap), _classNames), className);
  var Element = element;
  return /*#__PURE__*/_react.default.createElement(Element, _extends({
    className: stackClasses
  }, rest), children);
};

exports.default = Stack;
Stack.propTypes = {
  children: _propTypes.default.node,
  element: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  horizontalAlignment: _propTypes.default.oneOf(STACK_HORIZONTAL_ALIGNMENT),
  spacing: _propTypes.default.oneOf(STACK_SPACING),
  vertical: _propTypes.default.bool,
  verticalAlignment: _propTypes.default.oneOf(STACK_VERTICAL_ALIGNMENT),
  wrap: _propTypes.default.bool
};
Stack.defaultProps = {
  element: "div",
  horizontalAlignment: "left",
  spacing: "medium",
  vertical: false,
  verticalAlignment: "center",
  wrap: true
};
Stack.displayName = "Stack";